import { connect } from 'react-redux'
import SearchField from './SearchField'
import { changeSearchTerm } from '../../actionCreators';

const mapStateToProps = (state, ownProps) => ({
	layout: state.layout,
	searchTerm: state.search.term
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	onChange: (event) => dispatch(changeSearchTerm(event.target.value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchField);


// WEBPACK FOOTER //
// ./src/components/MapMenu/SearchFieldContainer.js